import angular from 'angular'
import ng from 'ng'
import webfonts from 'webfonts/webfonts'
import WebFontsDirective from 'webfonts/webfont.directive'
import webmodals from 'webmodals/_webmodals.app'

export default angular.module('webfonts', ['webmodals','infinite-scroll','ngStorage'])
    .value('webfonts', webfonts)
    .directive('webfont', WebFontsDirective)
    .name;
//, 'ui.mask', 'ui.select', 'ngSanitize']);